import { serviceTypes } from 'utils/constants/serviceTypes';
import { loginStatus } from 'utils/constants/status';

import iconDistress from 'images/icon_service_distress.svg';
import iconPatrol from 'images/icon_service_patrol.svg';
import iconTransportation from 'images/icon_service_transportation.svg';
import involvementInfo from 'static/event_involved_people.json';
import { t } from 'i18next';
import { startCase } from 'lodash';

export const mockTime = '2019-11-26T20:20:03.843385+08:00';
export const mockTimeZone = 'Asia/Jakarta';

export const languageInput = [
  { code: 'en', name: 'English' },
  { code: 'id', name: 'Indonesian' },
  { code: 'hi', name: 'Hindi' },
  { code: 'es', name: 'Spanish' },
];

export const transformLanguageOutput = [
  { id: 'en', code: 'en', name: 'English' },
  { id: 'id', code: 'id', name: 'Indonesian' },
  { id: 'hi', code: 'hi', name: 'Hindi' },
  { id: 'es', code: 'es', name: 'Spanish' },
];

export const languageDictionary = {
  en: 'English',
  id: 'Indonesian',
  hi: 'Hindi',
  es: 'Spanish',
};

export const rawCountryInput = [
  { code: 'sg', dialCode: '+65', name: 'Singapore' },
  { code: 'id', dialCode: '+62', name: 'Australia' },
];

export const transformCountryInput = [
  {
    id: 'sg',
    dialCode: '+65',
    name: '(+65) Singapore',
    code: 'sg',
    countryName: 'Singapore',
  },
  {
    id: 'id',
    dialCode: '+62',
    name: '(+62) Australia',
    code: 'id',
    countryName: 'Australia',
  },
];

export const countryDictionary = {
  sg: '+65',
  id: '+62',
};
export const mockContryList = [
  { id: 'SG', countryName: 'Singapore' },
  { id: 'AUS', countryName: 'Australia' },
];

// PERSONNEL
export const personnelStatus = [
  { id: loginStatus.AVAILABLE, name: 'Available' },
  { id: loginStatus.ON_TASK, name: 'On Critical Task' },
  {
    id: loginStatus.ON_INTERRUPTABLE_TASK,
    name: 'On Task',
  },
  {
    id: loginStatus.NOT_LOGGED_IN,
    name: 'Logged Out',
  },
  {
    id: loginStatus.ON_BREAK,
    name: 'On Break',
  },
];

export const patrolServiceOption = [
  {
    id: serviceTypes.patrol.singleSite,
    name: 'Site Patrol',
    icon: iconPatrol,
  },
  {
    id: serviceTypes.patrol.multiSite,
    name: 'Mobile Patrol',
    icon: iconPatrol,
  },
  {
    id: serviceTypes.emergency.standard,
    name: 'Emergency Response',
    icon: iconDistress,
  },
];
export const patrolServiceOptionForGuard = [
  {
    id: serviceTypes.patrol.singleSite,
    name: 'Site Patrol',
    icon: iconPatrol,
  },
  {
    id: serviceTypes.patrol.multiSite,
    name: 'Mobile Patrol',
    icon: iconPatrol,
  },
];

export const transportServiceOption = [
  {
    id: serviceTypes.transport.standard,
    name: 'Standard',
    icon: iconTransportation,
  },
  {
    id: serviceTypes.transport.secure,
    name: 'Secure',
    icon: iconTransportation,
  },
  {
    id: serviceTypes.transport.protection,
    name: 'Protection',
    icon: iconTransportation,
  },
];

export const days = [
  { id: 'MON', name: 'Monday' },
  { id: 'TUE', name: 'Tuesday' },
  { id: 'WED', name: 'Wednesday' },
  { id: 'THU', name: 'Thursday' },
  { id: 'FRI', name: 'Friday' },
  { id: 'SAT', name: 'Saturday' },
  { id: 'SUN', name: 'Sunday' },
];
export const everyDaySchedule = [
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
  'SUN',
];

export const startTime = '00:00';
export const endTime = '23:55';

export const intervalOptions = [
  { id: 'HOUR_HALF', name: 'thirty_minute_label' },
  { id: 'HOUR_ONE', name: 'one_hour_label' },
  { id: 'HOUR_TWO', name: 'two_hour_label' },
  { id: 'HOUR_THREE', name: 'three_hour_label' },
  { id: 'HOUR_FOUR', name: 'four_hour_label' },
  { id: 'HOUR_EIGHT', name: 'eight_hour_label' },
  { id: 'HOUR_TWELVE', name: 'twelve_hour_label' },
  { id: 'HOUR_TWENTY_FOUR', name: 'twenty_four_hour_label' },
];

export const intervalOptionsNumber = [
  { id: 30, name: 'thirty_minute_label' },
  { id: 60, name: 'one_hour_label' },
  { id: 120, name: 'two_hour_label' },
  { id: 180, name: 'three_hour_label' },
  { id: 240, name: 'four_hour_label' },
  { id: 360, name: 'six_hour_label' },
  { id: 480, name: 'eight_hour_label' },
  { id: 720, name: 'twelve_hour_label' },
  { id: 1440, name: 'twenty_four_hour_label' },
];

export const experiences = [
  { id: 'DEFENSIVE_DRIVING', name: 'defensive driving' },
  { id: 'ADVANCED_DRIVING', name: 'advanced driving' },
  { id: 'SECURITY', name: 'security' },
  { id: 'MILITARY', name: 'military' },
  { id: 'POLICE', name: 'police' },
  { id: 'EXECUTIVE_PROTECTION', name: 'executive protection' },
];

export const qualificationType = [
  { id: 'OFF_ROAD', name: 'Off Road Vehicle' },
  { id: 'SCOUT_DOG', name: 'Scout Dog' },
  { id: 'AK_47', name: 'AK-47' },
  { id: 'CITIBANK', name: 'Citibank' },
];

export const riskConsequences = [
  { id: 'INSIGNIFICANT', name: 'INSIGNIFICANT' },
  { id: 'MINOR', name: 'MINOR' },
  { id: 'MODERATE', name: 'MODERATE' },
  { id: 'MAJOR', name: 'MAJOR' },
  { id: 'SEVERE', name: 'SEVERE' },
];

export const riskLikelihood = [
  { id: 'RARE', name: 'RARE' },
  { id: 'UNLIKELY', name: 'UNLIKELY' },
  { id: 'POSSIBLE', name: 'POSSIBLE' },
  { id: 'LIKELY', name: 'LIKELY' },
  { id: 'ALMOST_CERTAIN', name: 'SEVERE' },
];

export const riskLevel = [
  { id: 'LOW', name: 'Low' },
  { id: 'MEDIUM', name: 'Medium' },
  { id: 'HIGH', name: 'High' },
  { id: 'EXTREME', name: 'Extreme' },
];

// patrol status
export const patrolStatus = [
  { id: 'NEW', name: 'New' },
  { id: 'IN_PROGRESS', name: 'In-Progress' },
  { id: 'RESOLVED_SUCCESSFUL', name: 'Resolved successful' },
  { id: 'RESOLVED_INCOMPLETE', name: 'Resolved Incomplete' },
  { id: 'RESOLVED_ABORTED', name: 'Resolved Aborted' },
];

export const involvementList = involvementInfo.involvement.map(item => ({
  id: item,
  name: item,
}));

export const audienceList = [
  { id: 'INTERNAL_AUDIENCE', name: 'Internal Audience' },
  { id: 'CLIENT_AUDIENCE', name: 'Client Audience' },
  { id: 'PUBLIC_AUDIENCE', name: 'Public Audience' },
];

export const patrolService = [
  serviceTypes.patrol.singleSite,
  serviceTypes.patrol.multiSite,
  serviceTypes.emergency.standard,
];

export const transportService = [
  serviceTypes.transport.standard,
  serviceTypes.transport.secure,
  serviceTypes.transport.protection,
];

export const emergencyResponseStatus = [
  { id: 'NEW', name: 'New' },
  { id: 'NEW_ASSIGNED', name: 'New Assigned' },
  { id: 'IN_PROGRESS_EN_ROUTE', name: 'In Progress En Route' },
  { id: 'IN_PROGRESS_ON_SITE', name: 'In Progress On Site' },
  { id: 'IN_PROGRESS_SAFE_ON_SITE', name: 'In Progress Safe On Site' },
  { id: 'IN_PROGRESS_VISUAL_CONTACT', name: 'In Progress Visual Contact' },
  {
    id: 'IN_PROGRESS_ALL_SAFE',
    name: 'In-Progress All Safe',
  },
  { id: 'RESOLVED', name: 'Resolved' },
  { id: 'RESOLVED_ABORTED', name: 'Resolved Aborted' },
];

export const repeatsEveryOptions = (option, number) => {
  const noOfWeeksOrMonths = [];
  const options = t(`${option}s`);
  for (let index = 1; index <= number; index += 1) {
    if (index === 1) {
      noOfWeeksOrMonths.push({
        id: index,
        name: `${index} ${t(option)}`,
      });
    } else {
      noOfWeeksOrMonths.push({
        id: index,
        name: `${index} ${options}`,
      });
    }
  }
  return noOfWeeksOrMonths;
};
const rescheduleWeekendsOptionsStrings = ['NO', 'SKIP', 'EARLIER', 'LATER'];
export const rescheduleWeekendsOptions = rescheduleWeekendsOptionsStrings.map(
  string => ({
    id: string,
    name: startCase(string.toLowerCase()),
  }),
);

// has all the options as rescheduleWeekendsOptions expect NO
export const rescheduleInvalidDates = rescheduleWeekendsOptions.filter(
  f => f.id !== 'NO',
);

export const numberArray = num => {
  return Array.from({ length: num }, (_, i) => {
    return {
      id: `${i + 1}`,
      name: `${i + 1}`,
    };
  });
};

export const dayOfMonthOptions = [
  {
    id: 1,
    name: 'First',
  },
  {
    id: 2,
    name: 'Second',
  },
  {
    id: 3,
    name: 'Third',
  },
  {
    id: 4,
    name: 'Fourth',
  },
  {
    id: 5,
    name: 'Last',
  },
];
